import useWriteAccess from '@app/src/hooks/useWriteAccess'
import { useGenerateMyProfile } from '@app/src/pages/Transparency/MySustainabilityProfile/useGenerateMyProfile'
import { useMyProfile } from '@app/src/pages/Transparency/MySustainabilityProfile/useMyProfile'
import { CircularProgress, Skeleton, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ConfigurationCollection from '../../ConfigurationCollection'

const SustainabilityProfileConfig: React.FC = () => {
  const { formatMessage } = useIntl()
  const hasWriteAccess = useWriteAccess()
  const { generateMyProfile, isGenerating } = useGenerateMyProfile()
  const { provider, hasInProgress, isLoading } = useMyProfile(false)

  const hasProfile = Boolean(provider)

  return (
    <ConfigurationCollection
      actionButtons={[
        {
          label: formatMessage({
            id: hasProfile
              ? 'configurations.sustainabilityProfileSettings.refresh'
              : 'mySustainabilityProfile.generate',
          }),
          onClick: generateMyProfile,
          loading: isGenerating,
          disabled: !hasWriteAccess || hasInProgress || isLoading,
          variant: 'contained',
        },
      ]}
    >
      <Stack mr={4} spacing={4}>
        <Stack bgcolor="common.white" borderRadius={2} p={4} spacing={2}>
          {isLoading ? (
            <Skeleton variant="text" width="60%" />
          ) : (
            <>
              <Typography color="text.secondary">
                {formatMessage({ id: 'configurations.sustainabilityProfileSettings.description' })}
              </Typography>
              {hasInProgress && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <CircularProgress size={16} />
                  <Typography variant="body2" color="text.secondary">
                    {formatMessage({ id: 'configurations.sustainabilityProfileSettings.inProgress' })}
                  </Typography>
                </Stack>
              )}
            </>
          )}
        </Stack>
      </Stack>
    </ConfigurationCollection>
  )
}

export default SustainabilityProfileConfig
